export const LICENSE_PLATE_DIGITS_LENGTH = 4
export const LICENSE_PLATE_LETTERS_LENGTH = 3

export type LicensePlateParts = {
  digits: string
  letters: string
}

export function normalizeLicensePlateDigits(
  value: string,
  maxLength: number = LICENSE_PLATE_DIGITS_LENGTH
): string {
  return value.replace(/\D/g, '').slice(0, maxLength)
}

export function normalizeLicensePlateLetters(
  value: string,
  maxLength: number = LICENSE_PLATE_LETTERS_LENGTH
): string {
  return value.replace(/[^a-zA-Z]/g, '').toUpperCase().slice(0, maxLength)
}

export function splitLicensePlate(plateNumber?: string): LicensePlateParts {
  return {
    digits: plateNumber ? normalizeLicensePlateDigits(plateNumber) : '',
    letters: plateNumber ? normalizeLicensePlateLetters(plateNumber) : '',
  }
}

export function buildLicensePlate({ digits, letters }: LicensePlateParts): string {
  const cleanDigits = normalizeLicensePlateDigits(digits)
  const cleanLetters = normalizeLicensePlateLetters(letters)

  if (!cleanDigits && !cleanLetters) return ''
  if (!cleanDigits) return cleanLetters
  if (!cleanLetters) return cleanDigits

  return `${cleanDigits}-${cleanLetters}`
}

export function updateLicensePlateDigits(plateNumber: string | undefined, nextDigits: string): string {
  const current = splitLicensePlate(plateNumber)
  return buildLicensePlate({ digits: nextDigits, letters: current.letters })
}

export function updateLicensePlateLetters(plateNumber: string | undefined, nextLetters: string): string {
  const current = splitLicensePlate(plateNumber)
  return buildLicensePlate({ digits: current.digits, letters: nextLetters })
}
